// espece slice
import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

const initialState = {
  especes: [],
  isLoading: false,
  error: false,
};

export const especeSlice = createSlice({
  name: "espece",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Espece
    getEspecesSuccess(state, action) {
      state.isLoading = false;
      state.especes = action.payload;
    },
    // create Espece
    createEspeceSuccess(state, action) {
      state.especes.push(action.payload);
    },
    // update Espece
    updateEspeceSuccess(state, action) {
      state.especes = state.especes.map((espece) => {
        if (espece.id === action.payload.id) {
          return action.payload;
        }
        return espece;
      });
    },
    // delete Espece
    deleteEspeceSuccess(state, action) {
      const { id } = action.payload;
      state.especes = state.especes.filter((espece) => espece.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getEspecesSuccess,
  createEspeceSuccess,
  updateEspeceSuccess,
  deleteEspeceSuccess,
} = especeSlice.actions;

// create Espece function

export const createEspece = (data) => async (dispatch) => {
  const { name } = data;
  const docRef = collection(firestore, "espece");
  const newData = {
    name: name,
    timestamp: serverTimestamp(),
  };

  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "espece", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createEspeceSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// Update Espece
export const updateEspece = (data) => async (dispatch) => {
  const { id, name } = data;
  const docRef = doc(firestore, "espece", id);
  const newData = {
    name: name,
  };
  try {
    dispatch(startLoading());
    await updateDoc(docRef, newData);
    dispatch(updateEspeceSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// delete Espece
export const deleteEspece = (id) => async (dispatch) => {
  const docRef = doc(firestore, "espece", id);
  try {
    dispatch(startLoading());
    await deleteDoc(docRef);
    dispatch(deleteEspeceSuccess({ id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};

// get Especes from firestore
export const getEspeces = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "espece"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getEspecesSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default especeSlice.reducer;
